import React, { useRef, useLayoutEffect, useEffect, useState } from 'react';
import styled from 'styled-components/macro';

import { PageTop } from './DefaultPage';
import PageElements from '@mirinae/lessons/components/lesson/PageElements';
import Phrase from '@mirinae/lessons/components/lesson/elements/Phrase';

import closeIcon from '@mirinae/lessons/assets/images/bubble-ok-btn.svg'
import pointerIcon from '@mirinae/lessons/assets/images/bubble-arrow-down.svg'

const HelpBubble = styled.div`
    display: flex;
    position: absolute;
    top:  ${props => props.geom.top - 10}px; // 132px; //
    right: 28px; // ${props => props.geom.left + 31}px;
    padding: 10px 16px;
    align-items: flex-end;
    width: 233px;
    border-radius: 15px;
    background: #FFF;
    box-shadow: 4px 2px 16px 0px #C8C8C8, -4px -2px 16px 0px #FFF;
  
    color: #525252;
    font-size: 12px;
    font-weight: 500;
    line-height: 15px; /* 125% */
  
    z-index: 100;
`;

const Close = styled.img`
    position: absolute;
    top: -44px;
    right: -20px;
    cursor: pointer;
`
const Pointer = styled.img`
    position: absolute;
    bottom: -18px;
    left: -50px;
`

const MeetTheWords = ({ page }) => {
    const [showBubble, setShowBubble] = useState(false);
    const [geom, setGeom] = useState({ top: -9999, left: -9999 });
    const bubbleElement = useRef(null);
    page.children.forEach(step => step.children.forEach(e => { if (e.type === 'helpBubble') bubbleElement.current = e; }));

    useEffect(() => {
        if (bubbleElement.current) {
            const phrase = document.querySelector('.phrase-wrapper');
            const bubble = document.querySelector('#bubble-help');
            if (phrase && bubble) {
                const placement = bubbleElement.current.fieldsByName.placement.value;
                setGeom({ top: phrase.offsetTop - bubble.clientHeight + 10, left: phrase.offsetLeft + 20 });
            }
        }
    }, [showBubble]);

    const mapComponent = (e) => {
        if (e.componentName === 'phrase') {
            e.mobile =  { ...(e.mobile || {}), style: { koFontWeight: 700, koreanFontSize: '50px', englishFontSize: '20px', enFontWeight: 500 } };
        }
    }

    return (
        <>
            <PageTop page={page} />
            <PageElements page={page} layoutFilter={e => e.componentName !== 'helpBubble'} mapComponent={mapComponent} mounted={() => setShowBubble(true)} />
            { showBubble && bubbleElement.current && bubbleElement.current.fieldsByName.text.value && (
                <HelpBubble id="bubble-help" geom={geom} >
                    <Close src={closeIcon} onClick={() => setShowBubble(false)}></Close>
                    {bubbleElement.current.fieldsByName.text.value}
                    <Pointer src={pointerIcon}></Pointer>
                </HelpBubble>
            )}
        </>
    );

};

export default MeetTheWords;
